/**
 * 搜尋結果清單的鍵盤導覽(REQ-20260903010)。
 *
 * 打單時不想為了選一筆結果去摸滑鼠:↓ / ↑ 移動高亮、Enter 等同點該列。
 *
 * `index === -1` 代表「沒有任何一列被高亮」,焦點語意仍在輸入框 —— 這個狀態很重要,
 * 呼叫端靠它決定 Enter 要交回原本的行為(例:進階搜尋的 Enter 是送出搜尋)。
 *
 * `onKeyDown` 回傳 boolean:true = 這個鍵已經被處理掉,呼叫端不要再做自己的事。
 */
import { useEffect, useState, type KeyboardEvent } from 'react';

export interface ListKeyboardNav {
  /** 目前高亮的列;-1 = 沒有高亮 */
  index: number;
  setIndex: (index: number) => void;
  /** 回傳 true 表示這個鍵已處理 */
  onKeyDown: (e: KeyboardEvent) => boolean;
}

export function useListKeyboardNav(
  count: number,
  onSelect: (index: number) => void,
): ListKeyboardNav {
  const [index, setIndex] = useState(-1);

  // 換了搜尋條件 → 清單整個換掉,不可以還指著舊的第 N 列
  useEffect(() => {
    setIndex(-1);
  }, [count]);

  const onKeyDown = (e: KeyboardEvent): boolean => {
    // 中文輸入法組字中的 Enter 是「選字」,絕對不能當成選定
    if (e.nativeEvent.isComposing) return false;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setIndex(Math.min(index + 1, count - 1));
      return true;
    }
    if (e.key === 'ArrowUp') {
      e.preventDefault();
      setIndex(index <= 0 ? -1 : index - 1);
      return true;
    }
    if (e.key === 'Enter' && index >= 0) {
      e.preventDefault();
      onSelect(index);
      return true;
    }
    return false;
  };

  return { index, setIndex, onKeyDown };
}
